import { Box } from "@mui/material";
import useTabParam from '../../../hooks/useTabParam';
import PillFilters from '../../AppointmentDeliveriesV2/shared/PillFilters';
import CODConfig from "./CODConfig";
import MerchantCODConfig from "./MerchantCODConfig";

const TABS = [
    { key: "1", label: "Merchant COD Config" },
    { key: "2", label: "COD Config" },
];

function CODConfigurationTabs() {
    const [view, setView] = useTabParam("1");

    return (
        <>
            <PillFilters pills={TABS} value={view} onChange={setView} />
            <Box>
                {view === "1" && <MerchantCODConfig />}
                {view === "2" && <CODConfig />}
            </Box>
        </>
    );
}

export default CODConfigurationTabs;
